@if (!commonQuestionnaireService.createMode) {
<div>
    @if (question.title) {
    <div class="title overflow-break-word full-width">
        <span>{{ question.number + 1 }}</span>
        <span [ngClass]="{ required: question.required && customerQuestionnaireService.displayVersion === 'full' }">
            {{ '. ' + question.title }}</span
        >
    </div>
    } @if (question.description) {
    <div class="description full-width m-t-5">
        {{ question.description }}
    </div>
    } @if (currentAnswer) {
    <div class="answer-body-container full-width m-t-32">
        <section>
            @for (option of currentAnswer; track option) {
            <div class="d-flex-center m-t-10 space-between">
                <mat-checkbox
                    class="multiple-selection-checkbox full-width m-b-5 break-word"
                    [checked]="option.checked"
                    [(ngModel)]="option.checked"
                    [ngClass]="{ 'flex-1': option.is_other_option }"
                    (change)="onSelectionChanged(option)"
                    color="primary"
                    [disabled]="commonQuestionnaireService.reviewMode && questionReview?.notification_type !== 'modify'"
                >
                    {{ option.is_other_option ? 'Other' : option.text }}
                </mat-checkbox>
                @if (option.is_other_option) {
                <textarea
                    class="other-option-textarea p-10 w-100 m-l-40"
                    type="text"
                    [disabled]="
                        !option.checked || (commonQuestionnaireService.reviewMode && questionReview?.notification_type !== 'modify')
                    "
                    [ngClass]="{ 'text-required': option.checked && option.text === '' }"
                    placeholder="Type here your answer"
                    (ngModelChange)="customerQuestionnaireService.onAnotherOptionChange(question, $event)"
                    [(ngModel)]="option.text"
                    maxlength="100"
                    cols="40"
                    rows="1"
                    cdkTextareaAutosize
                    required
                >
                </textarea>
                }
            </div>
            }
        </section>
    </div>
    }
    <app-question-footer
        (questionMarked)="onQuestionMarked($event)"
        [showOk]="hasAtLeastOneAnswer()"
        [questionIndex]="questionIndex"
        [question]="question"
    ></app-question-footer>
</div>
} @if (commonQuestionnaireService.createMode) {
<div class="question-create-panel p-b-35">
    @if (multipleForm) {
    <form [formGroup]="multipleForm.group">
        <div class="title no-border full-width">
            <div class="full-width input-form-field questionTitle m-t-10">
                @if (question.title) {
                <div class="title-number w-10-percent">
                    <mat-form-field
                        appearance="outline"
                        class="full-width title-input input-form-field"
                    >
                        <textarea
                            disabled
                            matInput
                            type="text"
                            class="title-textarea m-t-0 resize-none"
                            >{{ questionTitle }}</textarea
                        >
                    </mat-form-field>
                </div>
                }
                <div class="m-l--10">
                    <mat-form-field
                        appearance="outline"
                        class="full-width title-input input-form-field"
                    >
                        <textarea
                            matInput
                            type="text"
                            #titleTextarea
                            [placeholder]="questionPlaceholder"
                            formControlName="title"
                            (ngModelChange)="onTitleChange()"
                            cdkTextareaAutosize
                            class="title-textarea m-t-0"
                            cdkAutosizeMinRows="1"
                            cdkAutosizeMaxRows="5"
                            required
                        ></textarea>
                        @if (TitleControl?.invalid) {
                        <mat-error>
                            <span>{{ multipleForm.getReadableError('title') }}</span>
                        </mat-error>
                        }
                    </mat-form-field>
                </div>
            </div>
        </div>
        <div class="description text-left fs-13 m-t-7 no-border full-width">
            <mat-form-field
                appearance="outline"
                class="full-width input-form-field"
            >
                <textarea
                    matInput
                    type="text"
                    [placeholder]="descriptionPlaceholder"
                    (ngModelChange)="onDescriptionChange()"
                    formControlName="description"
                    class="description-textarea"
                    cdkTextareaAutosize
                    cdkAutosizeMinRows="1"
                    cdkAutosizeMaxRows="5"
                ></textarea>
            </mat-form-field>
        </div>
    </form>
    } @if (currentAnswer) {
    <div class="answer-body-container full-width">
        <section>
            @for (option of currentAnswer; track option; let i = $index) {
            <div class="d-flex justify-space-between align-baseline">
                @if (!option.is_other_option) {
                <div class="d-flex align-start">
                    @if (multipleForm.group.contains('option_' + i)) {
                    <mat-checkbox
                        class="multiple-selection-checkbox checkbox-create full-width align-self-center"
                        [checked]="option.checked"
                        [(ngModel)]="option.checked"
                        [ngModelOptions]="{ standalone: true }"
                        color="primary"
                        disabled
                    >
                    </mat-checkbox>
                    }
                    <mat-form-field
                        style="width: 500px"
                        appearance="outline"
                        class="full-width no-border input-form-field no-error-input"
                    >
                        <textarea
                            matInput
                            class="m-l-10 full-width text-left fs-13 multiple-option-input"
                            type="text"
                            maxlength="100"
                            rows="1"
                            style="font-size: 0.85rem !important"
                            cdkTextareaAutosize
                            [placeholder]="answerInputPlaceholder"
                            [(ngModel)]="option.text"
                            [ngClass]="{ invalid_input: getOptionControl(i)?.invalid }"
                            (ngModelChange)="onOptionAdded(option, i)"
                            required
                        >
                        </textarea>
                    </mat-form-field>
                </div>
                } @if (!option.is_other_option) {
                <div class="d-flex align-start align-self-center">
                    <button
                        [disabled]="!conditionalQuestions.length"
                        (click)="openConditionalPanel(i, $event)"
                        disableRipple
                        matSuffix
                        mat-icon-button
                        id="conditional_{{ i }}"
                        class="inline-block"
                    >
                        <mat-icon class="ds-icon-branching fs-18"></mat-icon>
                    </button>
                    @if (commonQuestionnaireService.createMode && panelOpenState[i]) {
                    <div
                        class="cq-create-conditional-logic-overlay"
                        (click)="changePanelOpenDisplay(i)"
                    >
                        <div
                            (click)="$event.stopPropagation()"
                            id="cq-create-conditional-logic"
                            class="p-7 create-option d-flex align-start flex-direction-column text-ellipsis"
                            [style.margin-left]="panelTargetRect?.left + 'px'"
                            [style.margin-top]="panelTargetRect?.top + 'px'"
                        >
                            @for (section of conditionalQuestions; track section) {
                            <mat-checkbox
                                [indeterminate]="checkIndeterminateState(option, section)"
                                [checked]="checkAllSelections(option, section)"
                                (change)="markAllConditionalQuestionsBySection($event, option, section)"
                                color="primary"
                            >
                                <span class="text-ellipsis">{{ section.section | uppercase }}</span>
                            </mat-checkbox>
                            @for (question of section.questions; track question; let questionIndex = $index) {
                            <mat-checkbox
                                (change)="markQuestionForConditionalLogic($event, section, question, option)"
                                [checked]="checkQuestionIsConditional(option, section, question)"
                                color="primary"
                            >
                                {{ commonQuestionnaireService.getConditionalQuestionNumber(section, question) + '. ' + question.title }}
                            </mat-checkbox>
                            }
                            <br />
                            }
                        </div>
                    </div>
                    }
                    <button
                        [disabled]="!cstQuestionnaireService.checkMinRequirements(currentAnswer, MIN_ROWS)"
                        [ngClass]="{ 'btn-disabled': !cstQuestionnaireService.checkMinRequirements(currentAnswer, MIN_ROWS) }"
                        (click)="onDeleteOption(i)"
                        disableRipple
                        matSuffix
                        mat-icon-button
                        class="inline-block"
                    >
                        <mat-icon class="cancel-btn fs-18">cancel</mat-icon>
                    </button>
                </div>
                }
            </div>
            }
        </section>
    </div>
    }
    <div class="d-flex-center justify-end edit-mode-question-footer m-t-10">
        <p
            (click)="addNewOption()"
            class="add-btn fs-12 p-t-1 p-l-15 p-b-1"
        >
            Add option
        </p>
    </div>
    @if (question.has_other_option_checked) {
    <div class="full-width d-flex-center m-t-5 justify-space-between">
        <mat-checkbox
            [(ngModel)]="question.has_other_option_checked.checked"
            (change)="checkOtherOption($event)"
            color="primary"
        >
            Add "Other" option with input from customer
        </mat-checkbox>
    </div>
    }
</div>
}
